import {
  Database, Info, ListTodo, Palette, PanelLeft, RefreshCw, Settings, Sun, Tag, Trash2, Wrench,
} from "@app/ui";
import type { ComponentType } from "react";
import type { I18nKey } from "../../lib/language.js";

export interface SettingsCategory {
  /** Route segment under /settings (also the nav key). */
  route: string;
  label: string;
  labelKey: I18nKey;
  /** One-line hint shown under the label on the category list. */
  blurb: string;
  blurbKey: I18nKey;
  /** Override `blurb` on mobile (e.g. when a desktop-only feature is hidden). */
  mobileBlurb?: string;
  mobileBlurbKey?: I18nKey;
  icon: ComponentType<{ className?: string }>;
  /** Only shown / routable when developer mode is on. */
  devOnly?: boolean;
}

/** Single source of truth for the settings rail + router order. */
export const SETTINGS_CATEGORIES: SettingsCategory[] = [
  { route: "general", label: "General", labelKey: "settings.category.general", blurb: "Language, time, region, startup", blurbKey: "settings.category.general.blurb", icon: Settings },
  { route: "appearance", label: "Appearance", labelKey: "settings.category.appearance", blurb: "Theme, text, block color", blurbKey: "settings.category.appearance.blurb", icon: Sun },
  { route: "organize", label: "Topics, Labels and Calendars", labelKey: "settings.category.organize", blurb: "Topics, calendars, labels — colors, order, visibility", blurbKey: "settings.category.organize.blurb", icon: Tag },
  { route: "theme", label: "UI Colors", labelKey: "settings.category.theme", blurb: "Colors, palettes, presets", blurbKey: "settings.category.theme.blurb", icon: Palette },
  { route: "tasks", label: "Tasks & calendar", labelKey: "settings.category.tasks", blurb: "New-entry defaults, reminders, subtasks, editor", blurbKey: "settings.category.tasks.blurb", icon: ListTodo },
  { route: "navigation", label: "Navigation", labelKey: "settings.category.navigation", blurb: "Sidebar items and keyboard shortcuts", blurbKey: "settings.category.navigation.blurb", mobileBlurb: "Sidebar items", mobileBlurbKey: "settings.category.navigation.mobileBlurb", icon: PanelLeft },
  { route: "sync", label: "Sync & accounts", labelKey: "settings.category.sync", blurb: "Account, multi-device sync, Google", blurbKey: "settings.category.sync.blurb", icon: RefreshCw },
  { route: "data", label: "Data & privacy", labelKey: "settings.category.data", blurb: "API key, import/export, backup", blurbKey: "settings.category.data.blurb", icon: Database },
  { route: "trash", label: "Trash", labelKey: "settings.category.trash", blurb: "Restore or permanently delete items", blurbKey: "settings.category.trash.blurb", icon: Trash2 },
  { route: "about", label: "About & feedback", labelKey: "settings.category.about", blurb: "Version, feedback, developer options", blurbKey: "settings.category.about.blurb", icon: Info },
  { route: "developer", label: "Developer", labelKey: "settings.category.developer", blurb: "Diagnostics, debug flags, error log", blurbKey: "settings.category.developer.blurb", icon: Wrench, devOnly: true },
];

/** The rail/list categories visible for the current developer-mode state. */
export function visibleCategories(developerMode: boolean): SettingsCategory[] {
  return SETTINGS_CATEGORIES.filter((c) => developerMode || !c.devOnly);
}
